/* 公式LINEの待機画面（2026-10-08 Claude作成）
   公式LINEボタンを押してから、LINEアプリの友だち追加画面に切り替わるまでの「真っ白」「ぐるぐる」の間に
   マスコット（ワンコイン）を出して離脱を防ぐ。snippets/fp-line-wait.liquid から全ページで読まれる。
   - 押した瞬間: 「公式LINEを開いています」＋3段階の進み具合
   - LINEアプリへ切り替わった後に戻ってきた人: キンゴリが「友だち追加はできましたか？」＋もう一度開くボタン
   - 開かないまま時間が過ぎた: 手動で開くボタン
   遷移そのもの（LIFF・記録）は fp-line.liquid / 各LPの処理のまま。ここは画面を出すだけで、遷移を止めない。 */
(function () {
  var w = window;
  if (w.fpLineWait) return;

  var LINE_HOSTS = /^(line\.me|[a-z0-9-]+\.line\.me|lin\.ee)$/i;
  function isLineLink(href) {
    if (!href || typeof href !== 'string') return false;
    if (/^line:\/\//i.test(href)) return true;
    var u;
    try { u = new URL(href, 'https://fitpeak.co/'); } catch (e) { return false; }
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
    if (LINE_HOSTS.test(u.hostname)) return true;
    return u.hostname === 'business-hub-beige.vercel.app' && /^\/api\/line-crm\/go\//.test(u.pathname);
  }

  function next(phase, ev) {
    if (ev === 'close') return 'idle';
    if (ev === 'click') return 'opening';
    if (phase === 'opening') {
      if (ev === 'hidden') return 'away';
      if (ev === 'pageshow') return 'back';
      if (ev === 'timeout') return 'stuck';
    }
    if (phase === 'away' && (ev === 'visible' || ev === 'pageshow')) return 'back';
    if (phase === 'stuck' && ev === 'hidden') return 'away';
    return phase;
  }

  w.fpLineWait = { isLineLink: isLineLink, next: next };

  /* ---------- 画面 ---------- */
  var cfg = w.fpLineWaitCfg || {};
  var ADD_URL = cfg.add || 'https://line.me/R/ti/p/%40956iyppc';
  var STUCK_MS = 7000;
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '');
  if (!isMobile || !document.addEventListener) return;

  var phase = 'idle', root = null, timer = 0, stepTimers = [];
  var TEXT = {
    opening: { img: 'open', ttl: '公式LINEを開いています', sub: '友だち追加ボタンが出るまで<br>このままお待ちください', steps: true },
    back: { img: 'back', ttl: '友だち追加はできましたか？', sub: 'LINEの画面で「追加」を押すと登録完了です。<br>ぐるぐるで止まっていたら<br>もう一度開いてください。', btn: 'もう一度LINEを開く', close: '追加できたので閉じる' },
    stuck: { img: 'open', ttl: 'LINEが開かないときは', sub: '下のボタンからLINEアプリで開けます', btn: 'LINEアプリで開く', close: '閉じる' }
  };

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function build() {
    root = el('div', 'fplw');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-live', 'polite');
    root.innerHTML =
      '<div class="fplw__card">' +
        '<div class="fplw__pic"><img alt="" width="132" height="132" decoding="async"></div>' +
        '<p class="fplw__ttl"></p><p class="fplw__sub"></p>' +
        '<ol class="fplw__steps"><li>LINEに接続</li><li>FITPEAKを表示</li><li>友だち追加ボタンを準備</li></ol>' +
        '<div class="fplw__bar"><i></i></div>' +
        '<a class="fplw__btn" target="_self" rel="noopener"></a>' +
        '<button type="button" class="fplw__close"></button>' +
      '</div>';
    root.querySelector('.fplw__close').addEventListener('click', function () { go('close'); });
    root.querySelector('.fplw__btn').addEventListener('click', function () { setTimeout(function () { go('click'); }, 0); });
    document.body.appendChild(root);
  }

  function render() {
    clearTimeout(timer);
    stepTimers.forEach(clearTimeout); stepTimers = [];
    if (phase === 'idle') { if (root) root.classList.remove('is-on'); document.documentElement.classList.remove('fplw-on'); return; }
    if (phase === 'away') return; /* LINEアプリの裏。画面はそのまま */
    if (!root) build();
    var t = TEXT[phase];
    var img = root.querySelector('img');
    var src = (cfg.img && cfg.img[t.img]) || '';
    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    img.parentNode.style.display = src ? '' : 'none';
    root.querySelector('.fplw__ttl').textContent = t.ttl;
    root.querySelector('.fplw__sub').innerHTML = t.sub;
    root.setAttribute('data-phase', phase);
    var steps = root.querySelectorAll('.fplw__steps li');
    for (var i = 0; i < steps.length; i++) steps[i].className = '';
    if (t.steps) {
      [0, 1100, 2300].forEach(function (ms, i) {
        stepTimers.push(setTimeout(function () {
          for (var j = 0; j < steps.length; j++) steps[j].className = j < i ? 'is-done' : (j === i ? 'is-now' : '');
        }, ms));
      });
      timer = setTimeout(function () { go('timeout'); }, STUCK_MS);
    }
    var btn = root.querySelector('.fplw__btn');
    btn.style.display = t.btn ? '' : 'none';
    if (t.btn) { btn.textContent = t.btn; btn.setAttribute('href', ADD_URL); }
    var close = root.querySelector('.fplw__close');
    close.textContent = t.close || '閉じる';
    close.className = 'fplw__close' + (t.close ? '' : ' is-quiet');
    root.classList.add('is-on');
    document.documentElement.classList.add('fplw-on');
  }

  function go(ev) {
    var p = next(phase, ev);
    if (p === phase && ev !== 'click') return;
    phase = p;
    render();
  }

  w.addEventListener('click', function (ev) {
    if (ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a || (root && root.contains(a))) return;
    if (!isLineLink(a.getAttribute('href'))) return;
    go('click');
  }, true); /* window の捕捉段階で拾う。LP（lp-line-login）は document の捕捉段階で stopPropagation するので、
               document やバブル段階に置くと待機画面が出ない（2026-10-08 本番LPで確認）。判定は書き換え前の line.me で行う */

  document.addEventListener('visibilitychange', function () { go(document.visibilityState === 'hidden' ? 'hidden' : 'visible'); });
  w.addEventListener('pagehide', function () { go('hidden'); });
  w.addEventListener('pageshow', function (e) { if (e.persisted) go('pageshow'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') go('close'); });

  /* 押したときに画像が即出るよう、読み込み後の空き時間に先読みしておく */
  function preload() { if (!cfg.img) return; for (var k in cfg.img) { var i = new Image(); i.decoding = 'async'; i.src = cfg.img[k]; } }
  if (document.readyState === 'complete') setTimeout(preload, 800);
  else w.addEventListener('load', function () { setTimeout(preload, 800); });
})();
